var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinantechSnlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 45.8280216 0 45.8280216 46 0 46"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESIGN-SYSTEM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Typography-+-Logotipo",
    transform: "translate(-678.000000, -427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(678.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,22.9999567 C0,10.2971145 10.2591157,-8.66585409e-05 22.9140108,-8.66585409e-05 C35.5693375,-8.66585409e-05 45.8280216,10.2971145 45.8280216,22.9999567 C45.8280216,35.7027989 35.5693375,46 22.9140108,46 C10.2591157,46 0,35.7027989 0,22.9999567",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.626859,26 C11.0515071,26 11.4769854,25.8370855 11.800764,25.511673 L24.4202429,12.8451713 C25.0686303,12.1943464 25.0686303,11.1389435 24.4202429,10.4881186 C23.7722706,9.83729379 22.7199901,9.83729379 22.0720178,10.4881186 L9.45295394,23.155037 C8.80415141,23.8054452 8.80415141,24.8612648 9.45295394,25.511673 C9.77673255,25.8370855 10.2022109,26 10.626859,26",
    id: "Fill-4",
    fill: "#06888F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0309778,21.4881314 L20.4118318,34.1545463 C19.7630251,34.8053881 19.7630251,35.8608185 20.4118318,36.5116603 C20.7360276,36.8370812 21.1606785,37 21.5857445,37 C22.0103953,37 22.4358764,36.8370812 22.7596571,36.5116603 L35.3788031,23.8448287 C36.0276099,23.1944036 36.0276099,22.1389732 35.3788031,21.4881314 C34.7304115,20.8372895 33.6789543,20.8372895 33.0309778,21.4881314",
    id: "Fill-6",
    fill: "#06888F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6487982,16 C11.079057,16 11.5101569,15.8349311 11.8382134,15.5052156 L14.450889,12.8826892 C15.1082638,12.2236803 15.1082638,11.1538989 14.450889,10.49489 C13.7943554,9.83503668 12.7281718,9.83503668 12.0720588,10.49489 L9.45938312,13.1174163 C8.80200835,13.7764253 8.80200835,14.8462066 9.45938312,15.5052156 C9.78743962,15.8349311 10.2185395,16 10.6487982,16",
    id: "Fill-8",
    fill: "#06888F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9933953,31.4945994 L30.3805818,34.1172642 C29.7235929,34.7763079 29.7235929,35.8461457 30.3805818,36.5051895 C30.7086556,36.8349224 31.1397782,37 31.5700597,37 C32.0007617,37 32.4314637,36.8349224 32.7595376,36.5051895 L35.3723511,33.8825247 C36.0297605,33.223481 36.0297605,32.1540654 35.3723511,31.4945994 C34.7162034,30.8351335 33.6499635,30.8351335 32.9933953,31.4945994",
    id: "Fill-10",
    fill: "#06888F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1309713,10 L29.4380188,10 C28.480176,10 27.7035819,10.7795116 27.7035819,11.7409527 C27.7035819,12.7023938 28.480176,13.4819054 29.4380188,13.4819054 L29.9440407,13.4819054 L9.47465045,34.0281938 C8.79691924,34.7080358 8.79691924,35.8104941 9.47465045,36.4899009 C9.81286564,36.8302571 10.2568815,37 10.7008973,37 C11.1444795,37 11.588929,36.8302571 11.9271442,36.4899009 L32.3965344,15.9436125 L32.3965344,16.3496897 C32.3965344,17.3111308 33.1731285,18.0906424 34.1309713,18.0906424 C35.0888141,18.0906424 35.8654082,17.3111308 35.8654082,16.3496897 L35.8654082,11.7409527 C35.8654082,10.7795116 35.0888141,10 34.1309713,10",
    id: "Fill-12",
    fill: "#06888F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinantechSnlogo);
export default __webpack_public_path__ + "static/media/FINANTECH_snlogo.3c8d615a1a6b94526d14fd8257290591.svg";
export { ForwardRef as ReactComponent };